import React, { Component } from 'react'
import { Grid, Box, TextField, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core'
import Robo from "../../../imagens/RoboCozinheiro.svg"
import AuthService from "../../../services/AuthService"
import Utils, { onlyDigits } from '../../../utils/Utils';
import Agendamento from './Agendamento';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/material.css'

const phoneInputStyle = {
    width: '100%',
    height: '56px',
    fontSize: '16px',
    backgroundColor: '#fff',
    border: '1px solid #c4c4c4',
    borderRadius: '4px'
}

export class Nome extends Component {

    constructor(props) {
        super(props);

        this.state = {
            telefoneValidationMsg: "",
            nomeValidationMsg: "",
            formaRetirada: [],
            buscandoFormasRetirar: false,
            tipoValidationMessage: "",
            paisSelecionadoCode: 'br',
            dialCodeAtual: '55',
        }
    }

    componentDidMount() {
        this.handleChange = this.handleChange.bind(this);

        let service = new AuthService()
        let idEmpresa = AuthService.getProfile().empresa.id

        this.setState({ buscandoFormasRetirar: true })
        service.get("/empresa/getOnly/" + idEmpresa + "?atributos=formaRetirada")
            .then(resp => {
                let formaRetirada = []
                try {
                    formaRetirada = JSON.parse(resp.formaRetirada || "[]")
                } catch (err) {
                    console.error("Forma de retirada do pedido na empresa não configurada ou incorreta.", err)
                }
                this.setState({ formaRetirada });
                this.setState({ buscandoFormasRetirar: false })
            }).catch(err => {
                console.error(err);
                this.setState({ buscandoFormasRetirar: false })
            })
    }

    handlePhoneChange = (value, country, e, formattedValue) => {
        this.setState({
            paisSelecionadoCode: country.countryCode,
            dialCodeAtual: country.dialCode,
        })

        const valueToSend = onlyDigits(value)
        const dialCodeLength = country.dialCode ? country.dialCode.length : 0
        const localPhoneLength = valueToSend.length > dialCodeLength ? valueToSend.length - dialCodeLength : 0

        let validationMsg = ""

        if (valueToSend.length <= dialCodeLength) {
            validationMsg = "Não pode ser vazio"
        } else if (country.countryCode === 'br') {
            if (localPhoneLength < 10 || localPhoneLength > 11) {
                validationMsg = "Número incompleto (DDD + Telefone)"
            }
        } else {
            if (localPhoneLength < 4) {
                validationMsg = "Telefone inválido"
            }
        }

        this.setState({ telefoneValidationMsg: validationMsg })

        this.props.handleChange({
            target: {
                name: 'telefone',
                value: valueToSend
            }
        })
    }

    handleChange(event) {
        if (event.target.name === "nome") {
            if (!event.target.value) {
                this.setState({ nomeValidationMsg: "Não pode ser vazio" })
            } else {
                this.setState({ nomeValidationMsg: "" })
            }
        }

        if (event.target.name === 'tipoDelivery') {
            let empresa = JSON.parse(localStorage.getItem("_profile")).empresa;
            let cart = JSON.parse(localStorage.getItem("_cart"));

            if (event.target.value === "ENTREGAR" && empresa.valorMinimo > cart.valorTotalPedido) {
                this.setState({ tipoValidationMessage: `valor minimo para entrega é de: ${Utils.formatNumber(empresa.valorMinimo)}` })
            } else {
                this.setState({ tipoValidationMessage: `` })
            }
        }
        this.props.handleChange(event);
    }

    render() {
        const { nomeValidationMsg, formaRetirada, buscandoFormasRetirar, tipoValidationMsg, paisSelecionadoCode } = this.state;
        const permiteEntregar = formaRetirada.indexOf("D") >= 0;
        const permiteRetirarLocal = formaRetirada.indexOf("L") >= 0;
        const permiteConsumirLocal = formaRetirada.indexOf("C") >= 0;

        let displayValue = this.props.pessoa.telefone || ''
        if (paisSelecionadoCode === 'br') {
            if (displayValue && !displayValue.startsWith('55')) {
                displayValue = '55' + displayValue
            }
        }

        return (
            <React.Fragment>
                <Grid spacing={2} container direction="row" >

                    <Grid item style={{ textAlign: 'center' }} xs={12}>
                        <Grid width="100%">
                            <Box style={{ margin: "0 auto" }}>
                                <img src={Robo} style={{ maxHeight: "20vh" }} alt="" />
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography align="center">
                            <strong>Poderia me passar seu nome e seu telefone?</strong>
                        </Typography>
                    </Grid>

                    <Grid item xs={12} >
                        <TextField
                            label="Nome completo"
                            name="nome"
                            value={this.props.pessoa.nome}
                            fullWidth
                            error={!!nomeValidationMsg}
                            onChange={event => this.handleChange(event)}
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <PhoneInput
                            country={paisSelecionadoCode}
                            value={displayValue}
                            onChange={this.handlePhoneChange}
                            inputStyle={phoneInputStyle}
                            containerStyle={{ width: '100%' }}
                            specialLabel="Telefone"
                            enableSearch={true}
                            disableSearchIcon={false}
                            searchPlaceholder="Pesquisar país..."
                            countryCodeEditable={false}
                            disableCountryGuess={true}
                            masks={{ br: '(..) .....-....' }}
                            priority={{ br: 0, us: 1, pt: 2, ar: 3 }}
                        />

                        {this.state.telefoneValidationMsg && (
                            <Typography variant="caption" color="error" style={{ marginLeft: 14, marginTop: 4, display: 'block' }}>
                                {this.state.telefoneValidationMsg}
                            </Typography>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <Box pt={1}>
                            <FormControl component="fieldset">
                                <RadioGroup value={this.props.tipoDelivery} name="tipoDelivery" onChange={event => this.handleChange(event)} >
                                    {permiteEntregar ?
                                        <FormControlLabel value="ENTREGAR" control={<Radio />} label="Quero receber em casa" /> : null}

                                    {permiteRetirarLocal ?
                                        <FormControlLabel value="RETIRAR_LOCAL" control={<Radio />} label="Quero retirar no local" /> : null}

                                    {permiteConsumirLocal ?
                                        <FormControlLabel value="CONSUMIR_LOCAL" control={<Radio />} label="Quero consumir no local" /> : null}
                                </RadioGroup>
                            </FormControl>

                            {buscandoFormasRetirar ? "Carregando...." : (
                                ((!permiteEntregar && !permiteRetirarLocal) ?
                                    <React.Fragment>
                                        <Typography display="block" align="center" color="primary" variant="body1">
                                            Nosso cardápio esta em modo consulta 🥺
                                        </Typography>
                                        <Box p={1}>
                                            <Typography align="center" color="primary" variant="subtitle2">
                                                Mas fique tranquilo
                                            </Typography>
                                        </Box>
                                        <Typography align="center" color="primary" variant="body1">
                                            Para finalizar, chame o garçom ou faça seu pedido direto no balcão 🙌👏
                                        </Typography>
                                    </React.Fragment>
                                    : null)
                            )}

                            {tipoValidationMsg ? (
                                <Typography>
                                    {tipoValidationMsg}
                                </Typography>
                            ) : null}
                        </Box>
                    </Grid>

                    {this.props.configuracaoAgendamento?.situacao === "A" || this.props.configuracaoAgendamento?.situacao === "NA" ? (
                        <Grid item xs={12}>
                            <Agendamento
                                configuracaoAgendamento={this.props.configuracaoAgendamento}
                                handleChangeDiaEHorario={this.props.handleChangeDiaEHorario}
                                selectedTimestampScheduleParam={this.props.selectedTimestampSchedule}
                                diaAgendamentoParam={this.props.diaAgendamento}
                                horaAgendamentoParam={this.props.horaAgendamento}
                                tipoDelivery={this.props.tipoDelivery} />
                        </Grid>
                    ) : null}

                </Grid>
            </React.Fragment>
        )
    }
}

export default Nome